import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from '@app/guards';

import { MainComponent } from './main/main.component';

import { DocumentsComponent } from './documents/documents.component';
import { FoldersComponent } from './folders/folders.component';
import { ConfigurationComponent } from './configuration/configuration.component';

import { DocumentsGroupComponent } from './documents-group/documents-group.component';
import { DocumentsOrganizationComponent } from './documents-organization/documents-organization.component';

import { ChangeOrganizationComponent } from '@app/pages/menu/change-organization/change-organization.component';

const routes: Routes = [
  {
    path: 'menu',
    component: MainComponent,
    canActivate: [AuthenticationGuard],
    children: [
      { path: '', redirectTo: '/menu/documentos', pathMatch: 'full' },
      { path: 'documentos', component: DocumentsComponent, data: { title: 'route.myDocuments' } },
      { path: 'documentos/grupo', component: DocumentsGroupComponent, data: { title: 'route.documentsGroup' } },
      { path: 'documentos/organizacao', component: DocumentsOrganizationComponent, data: { title: 'route.documentsOrganization' } },
      { path: 'pastas', component: FoldersComponent, data: { title: 'route.folders' } },
      { path: 'configuracoes', component: ConfigurationComponent, data: { title: 'route.settings' } },
      { path: 'alterar/organizacao', component: ChangeOrganizationComponent, data: { title: 'route.changeOrganization' } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuRoutingModule {}
